/**
 * Handles all Video tracking
 * @module trackVideo
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

export const DEFAULTS = {
  eventCategory: 'Beauty Video'
};

// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'trackVideo';
export const VIMEO_API_URL = 'https://player.vimeo.com/api/player.js';
export const YOUTUBE_API_URL = 'https://www.youtube.com/iframe_api';


/**
 * Setup players for respective video sources
 * @param  {jQuery} $el - iframe of video to track
 * @param  {string} string of video type to test source against
 */
const playerType = ($el, type) => {
  const src = $el.attr('src').toLowerCase();
  if (src.indexOf(type) !== -1) {
    return true;
  }
  return false;
};

/**
 * Clean title for GA tracking
 * @param  {string} video title
 * @return {string} clean title with no space or special characters
 */
const cleanTitle = title => title.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-');

/**
 * Set up Vimeo player event
 * @param  {object} vimeo player
 */
const setVimeoEvents = (player, opts) => {
  let videoTitle;
  player.getVideoTitle().then((title) => {
    videoTitle = cleanTitle(title);
  });
  player.on('play', () => {});
};
/**
 * Clean title for GA tracking
 * @param  {jQuery} $el - iframe of video to track
 * @return {string} unique id for youtube initialization
 */
const createUniqueID = ($el) => {
  const ytid = `yt-${Math.ceil(Math.random() * 10000000000)}`;
  $el.attr('id', ytid);
  return ytid;
};
/**
 * Init YouTube Player
 * @param  {event} youtube player event
 */
const onYouTubePlayerReady = (event) => {
  const videoTitle = cleanTitle(event.target.getVideoData().title);
  $(event.target.a).data('video-title', videoTitle);
};

/**
 * Init YouTube Player
 * @param  {jQuery} $el - iframe of video to track
* @return {object} YT Object
 */
const initYouTubeVideo = ($el, opts) => {
  const ytid = createUniqueID($el);
  return new YT.Player(ytid, {
    events: {
      onReady: onYouTubePlayerReady,
      onStateChange: (event) => {},
    },
  });
};
/**
 * Setup players for respective video sources
 * @param  {jQuery} $el - iframe of video to track
 */
const setupPlayer = ($el, opts) => {
  if (playerType($el, 'vimeo')) {
    const player = new Vimeo.Player($el);
    setVimeoEvents(player, opts);
  } else if (playerType($el, 'youtube')) {
    if (window.youtubeLoaded) {
      initYouTubeVideo($el,opts);
    }
    $(window).on('youtubeLoaded', () => {
      initYouTubeVideo($el, opts);
    });
  }
};
/**
 * Load correct api base on url
 * @param  {jQuery} $el - iframe of video to track
 */
const loadAPI = ($el, opts) => {
  let apiURL;
  if (playerType($el, 'vimeo')) {
    apiURL = VIMEO_API_URL;
  } else if (playerType($el, 'youtube')) {
    apiURL = YOUTUBE_API_URL;
  }
  $.ajax({
    url: apiURL,
    cache: true,
    dataType: 'script',
  })
  .done(() => {
    setupPlayer($el, opts);
  });
};
/**
 * Initializes modal.
 * @param {HTMLElement} el - iframe of video to track
 * @see DEFAULTS
 */
export default function trackVideo(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  loadAPI($el, opts);
}

/**
* Add event for YouTube API ready method
*/
window.onYouTubeIframeAPIReady = () => {
  $(window).trigger('youtubeLoaded');
  window.youtubeLoaded = true;
};

registerJQueryPlugin(PLUGIN_NAME, trackVideo);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/track-video.js